// Static bilingual UI strings. Keys used across the app.
export const t = {
  brand: { cn: "剑桥双语英语练习", en: "AEIS Bilingual Practice" },
  tagline: {
    cn: "为中国小学生量身打造的新加坡 AEIS 英语备考平台",
    en: "AEIS English prep, built for Chinese primary students",
  },

  nav_dashboard: { cn: "首页", en: "Dashboard" },
  nav_practice: { cn: "练习", en: "Practice" },
  nav_progress: { cn: "进步", en: "Progress" },
  nav_parent: { cn: "家长", en: "Parent" },

  login: { cn: "登录", en: "Sign in" },
  register: { cn: "注册", en: "Sign up" },
  logout: { cn: "退出", en: "Sign out" },
  guest_start: { cn: "以访客身份开始", en: "Start as guest" },
  email: { cn: "邮箱", en: "Email" },
  password: { cn: "密码", en: "Password" },
  name: { cn: "姓名", en: "Your name" },
  role: { cn: "身份", en: "I am a" },
  role_student: { cn: "学生", en: "Student" },
  role_parent: { cn: "家长", en: "Parent" },

  cat_a2: { cn: "7 – 9 岁 · CEQ A2 Key", en: "Ages 7 – 9 · A2 Key" },
  cat_b1: { cn: "10 – 12 岁 · CEQ B1 Preliminary", en: "Ages 10 – 12 · B1 Preliminary" },
  choose_category: { cn: "请选择你的年龄段", en: "Choose your age group" },

  skill_reading: { cn: "阅读理解", en: "Reading" },
  skill_vocabulary: { cn: "词汇", en: "Vocabulary" },
  skill_grammar: { cn: "语法", en: "Grammar" },
  skill_listening: { cn: "听力", en: "Listening" },
  skill_writing: { cn: "写作", en: "Writing" },
  skill_speaking: { cn: "口语", en: "Speaking" },

  submit: { cn: "提交", en: "Submit" },
  next: { cn: "下一题", en: "Next" },
  back: { cn: "返回", en: "Back" },
  start_practice: { cn: "开始练习", en: "Start practising" },
  see_explanation: { cn: "查看解析", en: "See explanation" },
  correct: { cn: "答对了！", en: "Correct!" },
  incorrect: { cn: "再想一想", en: "Not quite" },

  readiness_meter: { cn: "AEIS 达标度", en: "CEQ Readiness" },
  weak_areas: { cn: "待加强", en: "Focus areas" },
  streak: { cn: "连续学习", en: "Day streak" },
  daily_goal: { cn: "每日目标", en: "Daily goal" },
  attempts: { cn: "累计练习", en: "Total attempts" },

  play_audio: { cn: "播放音频", en: "Play audio" },
  reveal_transcript: { cn: "显示原文", en: "Show transcript" },
  record: { cn: "开始录音", en: "Record" },
  stop: { cn: "停止", en: "Stop" },
  submit_writing: { cn: "提交写作", en: "Submit writing" },
  generate_more: { cn: "AI 生成更多", en: "Generate more with AI" },

  parent_link: { cn: "关联孩子账户", en: "Link a child account" },
  parent_link_code: { cn: "关联码", en: "Link code" },
  parent_no_children: { cn: "尚未关联孩子", en: "No children linked yet" },
  your_link_code: { cn: "你的关联码", en: "Your link code" },
  copy: { cn: "复制", en: "Copy" },
};

export function pair(key) {
  return t[key] || { cn: key, en: key };
}
